// @core/api/endpoints/secret/get_kv_secret.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  KvSecretResponse,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * Read KV secret
 * Reads the latest version of a KV secret, or a specific version if specified. Returns the secret data along with version metadata.
 */
export async function GetKvSecret(
  engine_id: string,
  path: string,
  params?: {
    version?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<KvSecretResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/engines/:engine_id/kv/data/:path`;
  requestPath = requestPath.replace(':engine_id', encodeURIComponent(engine_id));
  requestPath = requestPath.replace(':path', encodeURIComponent(path));
  const requestOptions = options;
  return client.get<KvSecretResponse>(requestPath, { ...requestOptions, params });
}
